/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { i as isFunction_1 } from '../../../_chunks/dep-0b4185fe.mjs';
import { i as isNumber_1 } from '../../../_chunks/dep-869cd310.mjs';
import '../../../_chunks/dep-a48de419.mjs';
import '../../../_chunks/dep-3ca5fb38.mjs';
import '../../../_chunks/dep-7071345f.mjs';
import '../../../_chunks/dep-d2403b2f.mjs';
import '../../../_chunks/dep-c27b1c14.mjs';

function isRowSelectedDisabled(selectColumn, row, rowIndex) {
  var disabled = isFunction_1(selectColumn.disabled) ? selectColumn.disabled({
    row: row,
    rowIndex: rowIndex
  }) : selectColumn.disabled;

  if (selectColumn.checkProps) {
    if (isFunction_1(selectColumn.checkProps)) {
      disabled = disabled || selectColumn.checkProps({
        row: row,
        rowIndex: rowIndex
      }).disabled;
    } else if (selectColumn.checkProps === "object") {
      disabled = disabled || selectColumn.checkProps.disabled;
    }
  }

  return !!disabled;
}
function getColWidthAttr(col, attrKey) {
  var attr = col[attrKey];
  return isNumber_1(attr) ? attr : parseFloat(attr);
}

export { getColWidthAttr, isRowSelectedDisabled };
//# sourceMappingURL=utils.mjs.map
